module.exports = __webpack_public_path__ + "img/hr-level1_running_gun_mask.dc358554.png";